import { render, staticRenderFns } from "./purchasePlanConfig.vue?vue&type=template&id=1a243e34&scoped=true&"
import script from "./purchasePlanConfig.vue?vue&type=script&lang=js&"
export * from "./purchasePlanConfig.vue?vue&type=script&lang=js&"
import style0 from "./purchasePlanConfig.vue?vue&type=style&index=0&id=1a243e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a243e34",
  null
  
)

export default component.exports